import type { FaireProductEntity } from "../../entity_types/product";

export const p_84aknwkcbz: FaireProductEntity = {
  token: "p_84aknwkcbz",
  type: "product",
  name: "Thank You for Being Awesome Keychain Gift",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/e22eb7b96451a0129068585f4d585bafc1abafcf01e0d1406db105c5c81446fa.jpeg",
  priceDollars: 0.35,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
